import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import apisauce from '@mangovoice/apisauce'

export interface VersionInfo {
  version?: string
}

const api = apisauce.create({
  baseURL: '/',
  withCredentials: false,
})

interface LatestVersionInfoParams {
  options?: Omit<UseQueryOptions<VersionInfo, VersionInfo>, 'queryKey'>
  onQuerySuccess?: (data: VersionInfo) => void
}

/**
 * Fetches the latest upload timestamp from the server.
 * This is only used to detect when an update is available
 * because the version from package.json is not guaranteed
 * to be in version order since it is generated by the merge commit id.
 */
export const useLatestVersionInfo = ({
  options,
  onQuerySuccess,
}: LatestVersionInfoParams) => {
  return useQuery<VersionInfo, VersionInfo>({
    queryKey: ['currentAppVersion'],
    queryFn: async () => {
      const { data, ok } = await api.get<VersionInfo, VersionInfo>(
        'version_info.json',
      )

      if (!ok || !data) {
        return {}
      }

      onQuerySuccess?.(data)
      return data
    },
    ...options,
    retry: (options?.retry as number | boolean | undefined) ?? false,
  })
}
